import React, { useState, useEffect } from "react";
import EvaluationModal from "../EvaluationModal/EvaluationModal";
import { QuizIcon } from "../../assets/icons/icons";
import './style.css';

export default function DailyReflection() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <>
        {/* <div className="journal-entry">
            <h3>Create New Evaluation</h3>
            <p>Click the button below to create a new evaluation</p>
            <div className="reflection-art-container">
                <button onClick={toggleModal}>New Evaluation</button>
            </div>
            <EvaluationModal
                isOpen={isModalOpen}
                closeModal={toggleModal}
            />
        </div> */}
            <div className="action-tile">
                <div className="action-container">
                    <div className="action-title-container">
                        <h3>Create New Evaluation</h3>
                        <p>Click the button below to create a new evaluation</p>
                    </div>
                    <QuizIcon className='action-icon'/>
                </div>
                <div className="action-btn-container">
                    <button className="action-btn" onClick={toggleModal}>New Evaluation</button>
                </div>
                <EvaluationModal
                    isOpen={isModalOpen}
                    closeModal={toggleModal}
                />
            </div>
        </>
    );
}
